export function getTokenFromCookie() {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith('cdd_token=')) {
      return cookie.substring('cdd_token='.length);
    }
  }
  return null; // Token not found
}
